import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  Typography,
  Button,
  IconButton,
  Tab,
  Tabs,
  Switch,
} from "@mui/material";
import { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import AddAgeGroup from "../../Modals/addAgeGroup";
import React from "react";
import AddTemplate from "../../Modals/addTemplate";
import { useLazyGetSettingsQuery, useDeleteSettingsMutation, useLazyGetTemplateQuery, useUpdateTemplateMutation } from "../../services/settings";
import { isValidInput } from "../../utils/validations";
import { showError, showToast } from "../../constants/toasts";

import DeleteConfirmModal from "../../Modals/deleteConfirmModal";
import usePermission from "../../hooks/usePermission";
import Pagination from "../../components/Panigation";
import SwitchToggle from "../../components/SwitchToggle";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Settings = () => {
  const navigate = useNavigate();
  const {
    hasPermission,
    isLoading: permissionLoading,
    canView,
    canAddEdit,
    canDelete,
  } = usePermission({ module: "Settings", permission_type: "can_view" });
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [templateData, setTemplateData] = useState<any[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [debouncedSearchTerm1, setDebouncedSearchTerm1] = useState<string>("");
  const [getSettings] = useLazyGetSettingsQuery()
  const [deleteSettings] = useDeleteSettingsMutation();
  const [getTemplate] = useLazyGetTemplateQuery()
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [deleteOpen, setDeleteOpen] = useState(false);

  // Templates data will be populated from API
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [updateTemplate] = useUpdateTemplateMutation()
  const handleCloseModal = () => {
    setOpen(false);
  };
  const handleCloseModal1 = () => {
    setOpen1(false);
  };
  const totalPages = Math.ceil(totalCount / 10);
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const getAgeList = async () => {
    setIsLoading(true);
    try {
      const response = await getSettings({
        length: 10,
        start: page,
        search: debouncedSearchTerm,
      }).unwrap();
      if (response.status === 200) {
        setData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  const getTemplateList = async () => {
    setIsLoading(true);
    try {
      const response = await getTemplate({
        length: 10,
        start: page,
        search: debouncedSearchTerm1,
      }).unwrap();
      if (response.status === 200) {
        setTemplateData(response?.data?.response_object || []);
        setTotalCount(response?.data?.total_records || 0);
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  const handleStatusUpdate = async (id: number, status: boolean) => {
    const body = {
      is_active: status,
    };

    try {
      const response = await updateTemplate({ body, id }).unwrap();
      if (response?.status === 200) {
        showToast(
          `Template category ${!status ? "deactivated" : "activated"} successfully`
        );
        getTemplateList();
      } else {
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };
  const handleAgeDelete = async () => {
    if (!selectedId) return;
    try {
      await deleteSettings({ id: selectedId }).unwrap();
      showToast("Age group deleted successfully");
      getAgeList()
    } catch (e: any) {
      showError(e?.data?.message || "Failed to delete age group");
    }
    setDeleteOpen(false);
    setSelectedId(null);
  };
  useEffect(() => {
    getAgeList()
    getTemplateList()
  }, [page, debouncedSearchTerm, debouncedSearchTerm1])

  // Permission gating (after all hooks declared)
  if (permissionLoading) {
    return <div>Loading permissions...</div>;
  }

  if (!hasPermission) {
    return <div>Access Denied</div>;
  }

  return (
    <>
      <div className="main_title">
        <h1>Settings</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Settings
        </p>
      </div>
      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Age Group" {...a11yProps(0)} />
              <Tab label="Templates" {...a11yProps(2)} />
            </Tabs>
          </Box>
        </div>
      </div>
      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  placeholder="Search..."
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                      setPage(1);
                    }
                  }}
                />
              </Box>
            </div>
            {canAddEdit("Settings") && (
              <div className="right_s">
                <Button
                  className="btn btn_primary"
                  onClick={() => setOpen(true)}
                >
                  <AddIcon /> Add
                </Button>
              </div>
            )}
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Age Group</TableCell>
                  {(canAddEdit("Settings") || canDelete("Settings")) && (
                    <TableCell>Action</TableCell>
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      <Typography fontWeight="bold">{index + 1}</Typography>
                    </TableCell>
                    <TableCell>{`${row.start_range}-${row.end_range}`}</TableCell>
                    {(canAddEdit("Settings") || canDelete("Settings")) && (
                      <TableCell>
                        <div className="table_actions v2">
                          {canDelete("Settings") && (
                            <Box>
                              <IconButton onClick={() => { setSelectedId(row.id); setDeleteOpen(true); }}>
                                <img src="/static/images/trash2_icon.svg" alt="Delete" />
                              </IconButton>
                            </Box>
                          )}
                        </div>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {totalCount > 0 && (
            <Pagination
              module={data}
              page={page}
              onPageChange={handlePageChange}
              totalPages={totalPages}
              totalCount={totalCount}
              setPage={setPage}
            />
          )}
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  placeholder="Search..."
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setDebouncedSearchTerm1}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                      setPage(1);
                    }
                  }}
                />
              </Box>
            </div>

            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen1(true)}
              >
                <AddIcon /> Add
              </Button>
            </div>
          </div>

          <TableContainer className="table_container" sx={{ marginTop: 4 }}>
            <Table>
              <TableHead>
                <TableRow hover>
                  <TableCell>Sr. No.</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Message</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {templateData.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      <Typography fontWeight="bold">{index + 1}</Typography>
                    </TableCell>
                    <TableCell>{row.title}</TableCell>
                    <TableCell>{row.message}</TableCell>
                    <TableCell>
                      <SwitchToggle
                        defaultChecked={Boolean(row.is_active)}
                        onChange={(checked) =>
                          handleStatusUpdate(row?.id, checked)
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </CustomTabPanel>
      </div>
      <AddAgeGroup open={open} onClose={handleCloseModal} setOpen={setOpen} onSuccess={getAgeList} />
      <AddTemplate open={open1} onClose={handleCloseModal1} setOpen={setOpen1} onSuccess={getTemplateList} />
      {canDelete && canDelete("Settings") && (
        <DeleteConfirmModal
          open={deleteOpen}
          setOpen={setDeleteOpen}
          handleDelete={handleAgeDelete}
          title="Are you sure you want to delete this age group?"
          message="This action cannot be undone."
        />
      )}
    </>
  );
};

export default Settings;
